import { FunctionComponent } from 'react'

import cx from 'classnames'
import Skeleton from '@material-ui/lab/Skeleton'
import Grid from '@material-ui/core/Grid'

import { range } from 'libraries/lodash'
import TileButton from 'components/tiled-menu/TileButton'

const SkeletonTiles: FunctionComponent<SkeletonTilesProps> = ({ tileCount = 8 }) => (
  <Grid container spacing={2}>
    {range(0, tileCount).map((_, index) => (
      <Grid key={index} item xs={12} sm={4} md={3} lg={2}>
        <div className={cx('h7 bg-white relative')}>
          <TileButton
            classes={{ label: 'h-100 wait', root: 'h-100' }}
            disableRipple
            fullWidth
          >
            <div className='w-100 h-100 relative'>
              <Skeleton classes={{ root: 'w-100' }} />
              <Skeleton classes={{ root: 'w-100' }} />
              <Skeleton classes={{ root: 'absolute bottom4 left2' }} variant='circle' width={24} height={24} />
              <Skeleton classes={{ root: 'absolute bottom4 right4' }} variant='circle' width={24} height={24} />
            </div>
          </TileButton>
          <Skeleton classes={{ root: 'absolute bottom0 left0 w-100' }} variant='rect' height={4} />
        </div>
      </Grid>
    ))}
  </Grid>
)

interface SkeletonTilesProps {
  tileCount: number;
}

export default SkeletonTiles
